import Vue from 'vue';
import bus from '../../plugins/bus';
import template from './index.html';

export default Vue.extend({
  name: 'Arrow',
  template,
  methods: {
    onClick() {
      bus.$emit('arrow-clicked');
    },
  },
});



// WEBPACK FOOTER //
// ./src/js/components/arrow/index.js